import { Component } from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import {Patient} from "../../models/patient.model";
import {CurrentPatientService} from "../../services/currentPatient";
import {ComputationTypes} from "../../models/computation-types.data";

@IonicPage()
@Component({
  selector: 'page-overview-results',
  templateUrl: 'overview-results.html',
})
export class OverviewResultsPage {

  patient: Patient;
  computationTypes = ComputationTypes;
  computationTypesKeys = Object.keys(ComputationTypes);

  constructor(public navCtrl: NavController,
              private currentPatient: CurrentPatientService,
              public navParams: NavParams) {
    this.patient = this.currentPatient.get();
    this.patient.computeResults();
  }

  ionViewDidLoad() {}

  computeResults(key) {
    // let modal = this.modal.create(ResultsPage, { computationKey: key, patient: this.patient});
    // modal.present();
    this.navCtrl.push('Results',{ computationKey: key, patient: this.patient});

  }

}



// WEBPACK FOOTER //
// ./src/pages/overview-results/overview-results.ts